import React, { FC, useEffect } from 'react';
import { Slider } from '@mui/material';
import { TFunction } from 'i18next';
import { observer } from 'mobx-react-lite';
import { FilterLeftStore } from '@f_qwep/components/filters/filterLeftPanel/model/store/FilterLeft.store';

interface IFilterLeftQuantityProps {
    filter: any;
    currentTheme: any;
    styles: any;
    t: TFunction<'translation', undefined>;
    colors: any
    store: FilterLeftStore;
    filtersReducer: any;
}

export const FilterLeftQuantity: FC<IFilterLeftQuantityProps> = observer(({styles, t, filter, colors, currentTheme, store, filtersReducer}) => {
    const { setMinQuantity, setMaxQuantity, minQuantity, maxQuantity, handleChangeQuantity } = store;

    const sliderMinCount = 0;
    const sliderMaxCount = 100;

    useEffect(() => {
        filtersReducer({ type: 'minQuantity_input', payload: { minQuantity } });
    }, [minQuantity]);

    useEffect(() => {
        filtersReducer({ type: 'maxQuantity_input', payload: { maxQuantity } });
    }, [maxQuantity]);

    return (
        <>
            <div className={styles.listItemNav}>
                <h5 className={styles.subtitle}>{'Количество (шт.)'}</h5>
            </div>
            <div id="quantity" className={styles.listItemCheck}>
                <Slider
                    className={styles.slider}
                    size="small"
                    value={[filter?.minQuantity ?? 0, filter?.maxQuantity ?? 100]}
                    min={sliderMinCount}
                    max={sliderMaxCount}
                    onChange={(_, value) => handleChangeQuantity(value)}
                />
                <div className={styles.listItemDiv}>
                    <input
                        style={{ color: colors.omicron }}
                        placeholder={`${t('qwep.search.from')}`}
                        className={currentTheme === 'vinpin' ? styles.textvinpin : styles.text}
                        value={filter?.minQuantity}
                        type="number"
                        min="0"
                        onChange={setMinQuantity}
                    />
                    <input
                        style={{ color: colors.omicron }}
                        placeholder={`${t('qwep.search.to')}`}
                        className={currentTheme === 'vinpin' ? styles.textvinpin : styles.text}
                        value={filter?.maxQuantity}
                        type="number"
                        min="0"
                        onChange={setMaxQuantity}
                    />
                </div>
            </div>
        </>
    );
});